const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === "development"
    ? "https://odoo.mlholding.mn"
    : "https://odoo.mlholding.mn");

export const apiUrl = (path) => `${API_BASE_URL}${path}`;
